import type { FaireProductEntity } from "../../entity_types/product";

export const p_cuymykwj6k: FaireProductEntity = {
  token: "p_cuymykwj6k",
  type: "product",
  name: "Classic Stripe Wine Linen Tea Towel",
  brandToken: "b_80726895",
  brandName: "Our Heiday",
  imageUrl:
    "https://cdn.faire.com/fastly/9f13f946a8f6b2d451dd69340372b1344b0996690e9103e6cb918f39593d70b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d6a39acc141ea65efb5a71e2e3d2a9a0f04cecca5f785501dccbf7bc5a376a1.jpeg",
    "https://cdn.faire.com/fastly/82ba1b73438d72513f48981ed26501613c6a13dc8f60f05f25b0cd9038ec6021.jpeg",
    "https://cdn.faire.com/fastly/214159984faba6ed6e655d8c56538ee08940baf5f680ff9410c5634ead53f011.jpeg",
  ],
  priceDollars: 14,
  description:
    "A timeless wine striped tea towel that adds a warm, elegant touch to your kitchen. This 100% organic linen tea towel is the you’ll always reach for. Sustainably and ethically produced, made to last.\n\n𝐓𝐡𝐞 𝐁𝐞𝐚𝐮𝐭𝐲 𝐎𝐟 𝐋𝐢𝐧𝐞𝐧\n\nWe love linen’s ability to capture that refined-casual feel, but even more so because of its inherently beneficial properties. One of the most ancient textiles in the world, linen has stood the test of time and is made to last. The entire flax plant is used in production, requiring very little water and no pesticides or fertilizers to grow, making it the preferred choice for sustainability. Anti-bacterial, anti-fungal, and hypoallergenic, linen absorbs and dries more quickly than cotton. Use it often, use it well.\n\n• 100% organic, OEKO-TEX certified linen\n• Pre-softened\n• Suitable for washers and dryers, hang dry to keep wrinkle-free\n• Designed in LA by Our Heiday\n• Ethically produced and digitally printed by a small production house in Lithuania",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:25.809Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
